export interface GeocodeResult {
  id: number;
  name: string;
  admin1?: string;
  country: string;
  latitude: number;
  longitude: number;
}

export interface WeatherPoint {
  time: string;
  temperature: number;
  weatherCode: number;
  precipitationProbability: number;
  windSpeed: number;
}

export interface WeatherData {
  current: {
    temperature: number;
    apparentTemperature: number;
    weatherCode: number;
    windSpeed: number;
    precipitation: number;
  };
  daily: {
    temperatureMin: number;
    temperatureMax: number;
    precipitationProbability: number;
  };
  hourly: WeatherPoint[];
}

export type WeatherIconKind = 'sun' | 'cloud' | 'rain';

// Códigos WMO (https://open-meteo.com/en/docs) agrupados a nuestro set de íconos.
export function weatherCodeToLabel(code: number): string {
  if (code === 0) return 'Despejado';
  if (code <= 2) return 'Parcialmente nublado';
  if (code === 3) return 'Nublado';
  if (code <= 48) return 'Niebla';
  if (code <= 57) return 'Llovizna';
  if (code <= 67) return 'Lluvia';
  if (code <= 77) return 'Nieve';
  if (code <= 82) return 'Chubascos';
  return 'Tormenta';
}

export function weatherCodeToIcon(code: number): WeatherIconKind {
  if (code <= 1) return 'sun';
  if (code <= 3 || code <= 48) return 'cloud';
  return 'rain';
}

// Pronóstico extendido para la estación meteorológica (campo): además de lo
// del card de clima, trae humedad, lluvia en mm, dirección/ráfagas de viento
// y evapotranspiración, a 7 días.
export interface AgroForecastHour {
  time: string;
  temperature: number;
  humidity: number;
  precipitation: number;
  precipitationProbability: number;
  windSpeed: number;
  windGusts: number;
  windDirection: number;
  weatherCode: number;
}

export interface AgroForecastDay {
  date: string;
  weatherCode: number;
  temperatureMin: number;
  temperatureMax: number;
  precipitationSum: number;
  precipitationProbability: number;
  windSpeedMax: number;
  windGustsMax: number;
  windDirectionDominant: number;
  et0: number;
}

export interface AgroForecast {
  hourly: AgroForecastHour[];
  daily: AgroForecastDay[];
}
